/* Washington Diamond — appointment request form
   Adds a pending state on submit and, when the section is configured for a
   third-party endpoint, posts with fetch and swaps to the success panel in
   place. With {% form 'contact' %} the browser navigates normally and Shopify
   renders the success panel on return, so this only handles the pending state. */
(function () {
  function init(root) {
    if (!root || root.dataset.wdBookingReady === 'true') return;
    root.dataset.wdBookingReady = 'true';

    var form = root.querySelector('[data-wd-form]');
    var successPanel = root.querySelector('[data-wd-success]');
    var errorPanel = root.querySelector('[data-wd-error]');
    if (!form) return;

    var submit = form.querySelector('[data-wd-submit]');
    var submitLabel = submit ? submit.textContent : '';
    var endpoint = form.dataset.wdEndpoint || '';

    function pending(on) {
      if (!submit) return;
      submit.disabled = on;
      submit.style.opacity = on ? '0.6' : '';
      submit.style.cursor = on ? 'wait' : '';
      submit.textContent = on ? 'Sending…' : submitLabel;
    }

    function showError(message) {
      if (!errorPanel) return;
      errorPanel.hidden = false;
      var slot = errorPanel.querySelector('[data-wd-error-message]');
      if (slot && message) slot.textContent = message;
      errorPanel.setAttribute('role', 'alert');
    }

    form.addEventListener('submit', function (e) {
      if (!form.checkValidity()) return; // let the browser show field errors

      if (!endpoint) {
        // Shopify contact form — normal navigation, just show pending.
        pending(true);
        return;
      }

      e.preventDefault();
      if (errorPanel) errorPanel.hidden = true;
      pending(true);

      fetch(endpoint, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Request failed');
          form.hidden = true;
          if (successPanel) {
            successPanel.hidden = false;
            successPanel.setAttribute('tabindex', '-1');
            successPanel.focus();
          }
        })
        .catch(function () {
          pending(false);
          showError(
            'Something went wrong sending your request. Please try again, or call 703-536-3600 and we will book your time by phone.'
          );
        });
    });

    root.querySelectorAll('[data-wd-form-reset]').forEach(function (el) {
      el.addEventListener('click', function () {
        form.reset();
        form.hidden = false;
        if (successPanel) successPanel.hidden = true;
        if (errorPanel) errorPanel.hidden = true;
        pending(false);
        var first = form.querySelector('input, select, textarea');
        if (first) first.focus();
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-wd-booking]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-wd-booking]');
    if (root) init(root);
  });
})();
